import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Platform } from '@ionic/angular';
import { FreeTrialComponent } from '../free-trial/free-trial.component';
import { LoginComponent } from '../header/login/login.component';

@Component({
  selector: 'app-button-free-trial',
  templateUrl: './button-free-trial.component.html',
  styleUrls: ['./button-free-trial.component.scss']
})
export class ButtonFreeTrialComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public platform: Platform,
  ) { }
  openDialog_freetrial(): void {
    let width = this.platform.is("desktop") ? "60%" : "100%"
    const dialogRef = this.dialog.open(LoginComponent, {
      width: width,
      maxWidth: "100%",
    });
    dialogRef.afterClosed().subscribe(result => { });
  }
  ngOnInit() {

  }

}
